// removed by extract-text-webpack-plugin
module.exports = {"base":"colorTag__base___2KD6d print__printHidden___3GLMT","colorTagContainer":"colorTag__colorTagContainer___1Vs2- colorTag__base___2KD6d print__printHidden___3GLMT","colorTag":"colorTag__colorTag___d9Fzk colorTag__base___2KD6d print__printHidden___3GLMT","picker":"colorTag__picker___29usH","button":"colorTag__button___3JXOI"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/lib/icons/colorTag.css
// module id = 1553
// module chunks = 0